// Property disposition status and occupancy — LANIS values, their display
// labels, and the MISMO 3.4 mappings (both directions).
//
// A blank value ("") shows the SelectField's built-in "Select..." placeholder,
// so we don't add a Select entry to these lists.

// --- Disposition status (POINT "Status") -----------------------------------
export const RETAINED = "retained";
export const PENDING_SALE = "pending_sale";
export const SOLD = "sold";

export const DISPOSITION_STATUS = Object.freeze({
  [RETAINED]: "Retained",
  [PENDING_SALE]: "Pending Sale",
  [SOLD]: "Sold"
});

// LANIS -> MISMO OwnedPropertyDispositionStatusType (enum: Retain/PendingSale/Sold)
export const DISPOSITION_TO_MISMO = Object.freeze({
  [RETAINED]: "Retain",
  [PENDING_SALE]: "PendingSale",
  [SOLD]: "Sold"
});

export const DISPOSITION_FROM_MISMO = Object.freeze({
  Retain: RETAINED,
  PendingSale: PENDING_SALE,
  Sold: SOLD
});

// --- Occupancy (POINT "Intended Occupancy" / "Current Occupancy") -----------
export const PRIMARY = "primary";
export const SECONDARY = "secondary";
export const INVESTMENT = "investment";

export const OCCUPANCY = Object.freeze({
  [PRIMARY]: "Primary Residence",
  [SECONDARY]: "Secondary",
  [INVESTMENT]: "Investment"
});

// LANIS -> MISMO PropertyUsageType / PropertyCurrentUsageType
// (enum: PrimaryResidence/SecondHome/Investment/Other)
export const OCCUPANCY_TO_MISMO = Object.freeze({
  [PRIMARY]: "PrimaryResidence",
  [SECONDARY]: "SecondHome",
  [INVESTMENT]: "Investment"
});

export const OCCUPANCY_FROM_MISMO = Object.freeze({
  PrimaryResidence: PRIMARY,
  SecondHome: SECONDARY,
  Investment: INVESTMENT,
  Other: INVESTMENT
});
